import { checkDiff } from '../../../../../utils/formValidation/errorCheckingFunctions';

import {
    validateEndDate,
    validateEndStatusId,
    validateHourlyPay,
    validateHoursPerWeek,
    validateStartDate,
    validateVacancyTitle
} from './validationFunctions';

export const validate = (newEntry, initialState) => {
    let newErrors = {};

    newErrors = validateStartDate(newEntry.startDate, newErrors);
    if (newEntry?.endDate) {
        newErrors = validateEndDate(newEntry.endDate, newEntry.startDate, '', newErrors);
        newErrors = validateEndStatusId(newEntry.endStatusId, newErrors);
    }
    newErrors = validateVacancyTitle(newEntry?.vacancyTitle, newErrors);
    newErrors = validateHourlyPay(newEntry.hourlyPay, newErrors);
    newErrors = validateHoursPerWeek(
        newEntry.hoursPerWeek,
        newEntry.hoursPerWeekId,
        newErrors,
        newEntry.fixedFlexibleHour
    );
    if (Object.keys(newErrors).length < 1) newErrors = checkDiff(newEntry, initialState);
    return newErrors;
};
